const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
// pipaan/src/api/cartApi.js
// Utility functions for all cart API endpoints


const BASE_URL = API_BASE_URL;
let cartRequest = null;

function getAuthHeaders() {
  const token =
    sessionStorage.getItem("accessToken") ||
    localStorage.getItem("accessToken");
  return token ? { token } : {};
}


async function cartMutationResult(res) {
  const data = await res.json();
  if (res.ok && data.success) {
    cartRequest = null;
    window.dispatchEvent(new Event("cartUpdated"));
  }
  return data;
}

export async function addToCart(product_id, quantity = 1, variant_id = 0) {
    const token =
    sessionStorage.getItem("accessToken") ||
    localStorage.getItem("accessToken");
    console.log("ffffffffff token in addToCart api:", token);
  const res = await fetch(`${BASE_URL}/cart/add`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
     token,
    },
    body: JSON.stringify({ product_id, quantity, variant_id }),
  });
  return cartMutationResult(res);
}


export async function getCart() {
  const headers = getAuthHeaders();
  if (cartRequest && cartRequest.token === headers.token) {
    return cartRequest.promise;
  }
  const request = { token: headers.token };
  request.promise = fetch(`${BASE_URL}/cart`, {
    method: "GET",
    headers,
  }).then(res => res.json()).finally(() => {
    if (cartRequest === request) cartRequest = null;
  });
  cartRequest = request;
  return request.promise;
}


export async function updateCartItem(itemId, quantity, variant_id) {
  const res = await fetch(`${BASE_URL}/cart/${itemId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
    body: JSON.stringify({ quantity, variant_id }),
  });
  return cartMutationResult(res);
}


export async function removeCartItem(itemId) {
  const res = await fetch(`${BASE_URL}/cart/${itemId}`, {
    method: "DELETE",
    headers: {
      ...getAuthHeaders(),
    },
  });
  return cartMutationResult(res);
}


export async function clearCart() {
  const res = await fetch(`${BASE_URL}/cart/clear`, {
    method: "DELETE",
    headers: {
      ...getAuthHeaders(),
    },
  });
  return cartMutationResult(res);
}


export async function checkoutCart(payment_method, payment_method_id, shipping_address) {
  const res = await fetch(`${BASE_URL}/cart/checkout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
    body: JSON.stringify({ payment_method, payment_method_id, shipping_address }),
  });
  return cartMutationResult(res);
}
